"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimTrailingSpaces = void 0;
// Trim the multiple or trailing spaces for a given string
const trimTrailingSpaces = (str = '') => (str && str.length > 0 ? str.replace(/\s{2,}/g, ' ').trim() : str);
exports.trimTrailingSpaces = trimTrailingSpaces;
//# sourceMappingURL=trim.utils.js.map